import React, { useState } from 'react';
import { sidebarInfoAdmin, sidebarInfoCoach } from './SidebarInfo';
import sidebarLogout from './SidebarLogout';
import { SidebarInterface, SidebarProps } from './types';
import adminSettings from './adminSettings';
import strings from '../../resources/strings';
import { AppState } from '../../store/rootReducer';
import { getUserFullName, getUserEmail, getUserRoles, getUserContactTypes } from '../../store/auth/selectors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { requestSignOut } from '../../store/auth/actions';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import UserRoles from '../../resources/enums/UserRoles';

import './sidebar.scss';

const Sidebar: React.FC<SidebarProps> = (props: SidebarProps) => {
    const [actualPage, setActualPage] = useState(useLocation().pathname);
    const dispatch = useDispatch();

    const handleSignOut = () => {
        dispatch(requestSignOut());
    };

    const sidebarCoach = props.roles.includes(UserRoles.Coach)
        ? sidebarInfoCoach.filter(
              (x) => props.contactTypes?.includes(x.title.toLowerCase()) || x.title.toLowerCase() == 'about me',
          )
        : sidebarInfoCoach;
    const sidebarInfo = props.roles.includes(UserRoles.Coach) ? sidebarCoach : sidebarInfoAdmin;

    return (
        <div className="sidebars">
            <div className="sidebar-fix">
                <div className="sidebar">
                    <div className="sidebar-column">
                        <div className="sidebar-info info">
                            <AccountCircleIcon style={{ fontSize: '5rem' }} className="avatar" />
                            <span className="info-name">{props.fullName}</span>
                            <span className="info-email">{props.email}</span>
                        </div>
                        <span className="separator"></span>
                        <div className="sidebar-menu menu">
                            <ul className="list">
                                {sidebarInfo
                                    .filter(({ url }) => !props?.disabledRoutes?.includes(url))
                                    .map((item: SidebarInterface) => (
                                        <li
                                            key={item.id}
                                            onClick={() => {
                                                setActualPage(item.url);
                                            }}
                                        >
                                            <Link
                                                className={`list-item item ${
                                                    actualPage.toLocaleLowerCase() === item.url.toLocaleLowerCase()
                                                        ? 'item_active'
                                                        : ''
                                                }`}
                                                to={item.url}
                                            >
                                                <item.img fontSize="large" />
                                                <span className="item-title">{item.title}</span>
                                            </Link>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                        <span className="separator"></span>
                        {props.roles.includes(UserRoles.SuperAdmin) && (
                            <div className="sidebar-adminSettings adminSettings">
                                <span className="adminSettings-title">{strings.sidebar.sectionTitle}</span>
                            </div>
                        )}
                        <div className="sidebar-menu menu">
                            <ul className="list">
                                {adminSettings
                                    .filter((item) => {
                                        if (!item.roles || props.roles.some((r) => item.roles?.includes(r)))
                                            return item;
                                    })
                                    .map((item: SidebarInterface) => (
                                        <li
                                            key={item.id}
                                            onClick={() => {
                                                setActualPage(item.url);
                                            }}
                                        >
                                            <Link
                                                className={`list-item item ${
                                                    actualPage.toLocaleLowerCase() === item.url.toLocaleLowerCase()
                                                        ? 'item_active'
                                                        : ''
                                                }`}
                                                to={item.url}
                                            >
                                                <item.img fontSize="large" />
                                                <span className="item-title">{item.title}</span>
                                            </Link>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                        <div className="sidebar-bottom">
                            <span className="separator"></span>
                            <div className="sidebar-menu">
                                <ul className="list">
                                    <li className="list-item item" key={sidebarLogout.id} onClick={handleSignOut}>
                                        <sidebarLogout.img fontSize="large" />
                                        <span className="item-title">{sidebarLogout.title}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        fullName: getUserFullName(state),
        email: getUserEmail(state),
        roles: getUserRoles(state),
        contactTypes: getUserContactTypes(state),
    };
}

export default connect(mapStateToProps)(Sidebar);
